import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Services from "@/pages/Services";
import Booking from "@/pages/Booking";
import CreatorProfile from "@/pages/CreatorProfile";
import StoriesExperience from "@/pages/StoriesExperience";

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="bottom-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StoriesExperience />} />
          <Route path="/classic" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/creator/:slug" element={<CreatorProfile />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
